import request from '@/plugins/request'

export function getEtfList(key, pageindex, pagesize, orderType) {
    return request({
        url: '/v1/Etf/GetEtfList',
        method: 'post',
        data: {
            skey: key,
            pageIndex: pageindex,
            pageSize: pagesize,
            orderType: orderType
        }
    })
}

export function getEtfPcf(etfid, date) {
    return request({
        url: '/v1/Etf/GetEtfPcf',
        method: 'post',
        data: {
            etfId: etfid,
            billdate: date
        }
    })
}
